import GenerateEmail from '../../components/AIEmailGeneration/GenerateEmail'

export default GenerateEmail